import { cn } from '@utils/cn'

interface BillingPeriodToggleProps {
  readonly annual: boolean
  readonly onToggle: () => void
  readonly className?: string
}

/** Toggle mensal/anual com altura fixa — evita sobreposição quando o badge "Poupa 2 meses" aparece/desaparece. */
export function BillingPeriodToggle({ annual, onToggle, className }: BillingPeriodToggleProps) {
  return (
    <div
      className={cn(
        'relative z-10 mx-auto flex w-full max-w-sm flex-col items-center gap-2 py-1',
        className
      )}
    >
      <div className="flex w-full max-w-[18rem] items-center justify-center gap-3 rounded-full border border-secondary-200 bg-white px-4 py-2.5 shadow-md sm:max-w-none sm:w-auto">
        <span className={cn('shrink-0 text-sm font-medium', !annual ? 'text-secondary-900' : 'text-secondary-400')}>
          Mensal
        </span>
        <button
          type="button"
          role="switch"
          aria-checked={annual}
          aria-label={annual ? 'Preços anuais ativos' : 'Preços mensais ativos'}
          onClick={onToggle}
          className={cn(
            'relative h-7 w-12 shrink-0 rounded-full transition-colors',
            annual ? 'bg-primary-600' : 'bg-secondary-300'
          )}
        >
          <span
            className={cn(
              'absolute top-0.5 left-0.5 h-6 w-6 rounded-full bg-white shadow transition-transform',
              annual ? 'translate-x-5' : 'translate-x-0'
            )}
          />
        </button>
        <span className={cn('shrink-0 text-sm font-medium', annual ? 'text-secondary-900' : 'text-secondary-400')}>
          Anual
        </span>
      </div>

      {/* Espaço sempre reservado — nunca colapsa nem sobrepõe o conteúdo abaixo */}
      <p
        className={cn(
          'min-h-[1.375rem] text-center text-xs font-semibold text-primary-600 transition-opacity duration-200',
          annual ? 'opacity-100' : 'opacity-0'
        )}
        aria-hidden={!annual}
      >
        Poupa 2 meses
      </p>
    </div>
  )
}
